import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.projects.views.ProjectDetailView.';

  public static readonly provideProjectTitle = `${Id.prefix}provideProjectTitle`;
  public static readonly projectTitle = `${Id.prefix}projectTitle`;
  public static readonly projectBudget = `${Id.prefix}projectBudget`;
  public static readonly projectDescription = `${Id.prefix}projectDescription`;
  public static readonly created = `${Id.prefix}created`;
  public static readonly lastModified = `${Id.prefix}lastModified`;
}

export class LangProjectDetailView {
  private constructor() {}

  public static provideProjectTitle(): string {
    return interpolate(Id.provideProjectTitle);
  }
  public static projectTitle(): string {
    return interpolate(Id.projectTitle);
  }
  public static projectBudget(): string {
    return interpolate(Id.projectBudget);
  }
  public static projectDescription(): string {
    return interpolate(Id.projectDescription);
  }
  public static created(): string {
    return interpolate(Id.created);
  }
  public static lastModified(): string {
    return interpolate(Id.lastModified);
  }
}

export class ProjectDetailViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.provideProjectTitle,
      "Please provide a {{glossary 'project'}} Title",
      'Validation for project title'
    );
    register.add(Id.projectTitle, "{{glossary 'project'}} Title", 'Label for project title');
    register.add(Id.projectBudget, "{{glossary 'project'}} Budget", 'Label for project budget');
    register.add(Id.projectDescription, "{{glossary 'project'}} Description", 'Label for project description');
    register.add(Id.created, 'Created', 'Label for created date');
    register.add(Id.lastModified, 'Last Modified', 'Label for last modified date');
  }
}
